import { MDBBtn, MDBChip, MDBIcon, MDBInputGroup, MDBModalFooter, MDBTable, MDBTableBody, MDBTableHead } from "mdb-react-ui-kit";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { customSearch, useAutoFocusSearchAfterLoads } from "../../../components/CustomSearchUtil/CustomSearch";
function AddToBillingGroup(props) {
  const { t, i18n } = useTranslation();
  const [addGroups, setAddGroups] = useState([]);
  const [removeGroups, setRemoveGroups] = useState([]);
  const [updatesourcedel, setUpdateSourceDel] = useState(false);
  const [selecteddGroups, setSelecteddGroups] = useState([]);
  const [sourceGroups, setSourceGroups] = useState([]);
  const [searchSourceQuery, setSearchSourceQuery] = useState("");
  const [searchDetinationQuery, setSearchDetinationQuery] = useState("");
  const [addGroupsids, setAddGroupsids] = useState(new Set());
  const [dataLoaded, setDataLoaded] = useState(false);
    const searchRef = useRef(null);
    useAutoFocusSearchAfterLoads(dataLoaded,setDataLoaded,searchRef,true)
  const basicData = {
    columns: [
      { label: "Name", field: "group_name", sort: true },
      { label: "Type", field: "group_type" },
    //   { label: "location", field: "location_name" },
    ],
    rows: sourceGroups,
  };

  const filteredData = customSearch(sourceGroups, searchSourceQuery, [ "group_name", "group_type", ]);


  const addGroup = (selectedObj) => {
    //debugger;
    const itemIdex = addGroups.findIndex(
      (item) => item.billing_group_id === selectedObj.billing_group_id
    );
    if (itemIdex === -1) {
      const updatedGroups = [...addGroups, selectedObj];
      setAddGroups(updatedGroups);
      const addGroupsIds = new Set(updatedGroups.map((item) => item.billing_group_id));
      setAddGroupsids(addGroupsIds);
    } else {
      const updateList = [...addGroups];
      updateList.splice(itemIdex, 1);
      setAddGroups(updateList);
      const addGroupsIds = new Set(updateList.map((item) => item.billing_group_id));
      setAddGroupsids(addGroupsIds);
    }

    const newRemoveList = removeGroups.filter(
      (item) => item.billing_group_id !== selectedObj.billing_group_id
    );
    setRemoveGroups(newRemoveList);
  };

  const handleDelete = (removeObj) => {
    const updateAddList = addGroups.filter(
      (item) => item.billing_group_id !== removeObj.billing_group_id
    );
    setAddGroups(updateAddList);
    const addGroupsIds = new Set(updateAddList.map((item) => item.billing_group_id));
    setAddGroupsids(addGroupsIds);
  };

  function setSelectAll(e) {
    e.preventDefault();
    e.stopPropagation();
    if (filteredData.length === 0) {
            return;
        }
    const addgroupIds = new Set(addGroups.map((item) => item.billing_group_id));
    const newAddGroups = filteredData.filter(
      (item) => !addgroupIds.has(item.billing_group_id)
    );
    const finalAddGroups = addGroups.concat(newAddGroups);
    setAddGroups(finalAddGroups);
    const finaladdgroupIds = new Set(finalAddGroups.map((item) => item.billing_group_id));
    setAddGroupsids(finaladdgroupIds);
  }

  useEffect(() => {
    if (props.sourceGroups?.length > 0 && !updatesourcedel) {
      setSelecteddGroups(props.selectedGroups);
      const selectedGroupsIds = new Set(
        props.selectedGroups.map((item) => item.billing_group_id)
      );
      const updatedSourceList = props.sourceGroups.filter(
        (items) => !selectedGroupsIds.has(items.billing_group_id)
      );
      setSourceGroups(updatedSourceList);
      setUpdateSourceDel(true);
    }
    if(!dataLoaded){  setDataLoaded(true)}
  }, [props.sourceGroups, updatesourcedel]);

  function setFinalAddGroups(e) {
    e.preventDefault();
    e.stopPropagation();
    props.setUpdateGroups(addGroups);
    props.setUpdateGroupsExecuted(true);
    props.onClose();
  }

  return (
    <>
      <div>
        <div className="pt-3">
          {(selecteddGroups.length > 0 || addGroups.length > 0) && (
          <MDBInputGroup
            className="mb-3"
            textAfter={<MDBIcon fas icon="search" />}
          >
            <input
              className="form-control"
              type="text"
              placeholder="Search"
              value={searchDetinationQuery}
              onChange={(e) => setSearchDetinationQuery(e.target.value)}
            />
          </MDBInputGroup>)}
          <div className="form-group row">
            <div className="col-12">
              <div className="form-outlines phoneNumberheight p-0">
                <div className="chips chips-placeholder">
                {selecteddGroups && selecteddGroups.length > 0 || addGroups && addGroups.length > 0 ? <>
                  {/* {selecteddGroups &&
                    selecteddGroups.length > 0 &&
                    selecteddGroups
                      .filter((item) => {
                        const lowercasedTitle = item.group_name.toLowerCase();
                        // const isTitleMatch = lowercasedTitle.includes(
                        //   searchDetinationQuery.toLowerCase()
                        // );
                        const regex = new RegExp(`\\b${searchDetinationQuery.toLowerCase()}`, "i");
                        const isTitleMatch = regex.test(lowercasedTitle);
                        const isCodeMatch =
                          item.billing_group_id &&
                          item.billing_group_id.toString().includes(searchDetinationQuery);
                        return isTitleMatch || isCodeMatch;
                      })
                      .map((item) => (
                        <MDBChip
                          key={item.billing_group_id}
                          className="m-chip d-inline py-2 px-3"
                        >
                          {item.group_name}
                        </MDBChip>
                      ))} */}
                    {selecteddGroups &&
                      selecteddGroups.length > 0 &&
                      customSearch(selecteddGroups, searchDetinationQuery, [
                        "group_name",
                        "billing_group_id",
                      ]).map((item) => (
                        <MDBChip
                          key={item.billing_group_id}
                          className="m-chip d-inline py-2 px-3"
                        >
                          {item.group_name}
                        </MDBChip>
                      ))}
                  {addGroups &&
                    addGroups.length > 0 &&
                    addGroups.map((item) => (
                      <MDBChip
                        onDelete={() => handleDelete(item)}
                        className="m-chip d-inline py-2 px-3"
                        key={item.billing_group_id}
                        closeIcon
                        size="sm"
                      >
                        {item.group_name}
                      </MDBChip>
                    ))}
                  </> : <>
                    <p className='m-1 text-secondary'>
                      The selected Groups will appear in this section
                    </p>
                  </>}
                </div>
              </div>
              <label
                className="my-3 text-primary cursor-pointer "
                onClick={(e) => setSelectAll(e)}
              >
                {t("selectAll")}
              </label>
              <MDBInputGroup
                className="mb-3"
                textAfter={<MDBIcon fas icon="search" />}
              >
                <input
                  className="form-control"
                  type="text"
                  ref={searchRef}
                  placeholder="Search"
                  value={searchSourceQuery}
                  onChange={(e) => setSearchSourceQuery(e.target.value)}
                />
              </MDBInputGroup>
              <div className="addAdminTable_height">
                <MDBTable className="mt-3" hover itemScope small>
                  <MDBTableHead className="table-header-sticky">
                    <tr>
                      {basicData?.columns &&
                        basicData.columns.map((col) => {
                          return (
                            <th scope="col" key={col.field}>
                              {col.label}
                            </th>
                          );
                        })}
                    </tr>
                  </MDBTableHead>
                  <MDBTableBody>
                   {filteredData.length > 0 && 
                      filteredData.map
                      ((row) => (
                          <tr
                            className={
                              addGroupsids?.has(row.billing_group_id)
                                ? "addUsers-select"
                                : ""
                            }
                            onClick={() => addGroup(row)}
                          >
                            {basicData?.columns.map((column) => (
                              <td className="cursor-pointer">
                                {row[column.field]}
                              </td>
                            ))}
                          </tr>
                        ))}
                    {sourceGroups == undefined ||
                      (sourceGroups?.length == 0 && (
                        <td colSpan={3} className="text-center">
                          No records found
                        </td>
                      ))}
                  </MDBTableBody>
                </MDBTable>
              </div>
            </div>
          </div>
        </div>
      </div>

      <MDBModalFooter>
        <MDBBtn color="secondary" onClick={(e) => props.onClose(e)}>
          {t("close")}
        </MDBBtn>
        <MDBBtn onClick={(e) => setFinalAddGroups(e)}>{t("add")}</MDBBtn>
      </MDBModalFooter>
    </>
  );
}
export default AddToBillingGroup;
